import { createStore } from 'vuex'
import axios from 'axios';
import createPersistedState from "vuex-persistedstate";

import auth from "./auth";
import user from "./user";
import department from "./department";
import partner from "./partner";
import category from "./category";
import lesson from "./lesson";
import quiz from "./quiz";
import dashboard from "./dashboard";
import faq from "./faq";
import assessment from "./assessment";
import maintenance from "./maintenance";
import resetUser from './reset-user';
import userStatistic from './user-statistic';

import owner from "./owner";
import employee from "./employee";
const plugin = store => {
  store.subscribe((mutation, state) => {
    switch (mutation.type) {
      case 'SET_ACCESS_TOKEN':
        if (mutation.payload) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${mutation.payload}`
          localStorage.setItem('accessToken', mutation.payload)
        } else {
          axios.defaults.headers.common['Authorization'] = null
          localStorage.removeItem('accessToken')
        }
        break;
      case 'SET_PROFILE':
        if (mutation.payload) {
          localStorage.setItem('profile', JSON.stringify(mutation.payload))
        } else {
          localStorage.removeItem('profile')
        }
        break;
    }
  })
}

const store = createStore({
  state: {
    lang: localStorage.getItem('Lang') || 'th'
  },
  getters: {
  },
  mutations: {
    onLangChanged(state, payload) {
      localStorage.setItem('Lang', payload.locale === 'en' ? 'th' : 'en')
      payload.locale = payload.locale === 'en' ? 'th' : 'en'
      state.lang = payload.locale
    }
  },
  actions: {
    changeLanguage({ commit }, payload) {
      commit('onLangChanged', payload)
    }
  },
  modules: {
    auth,
    user,
    department,
    partner,
    category,
    lesson,
    quiz,
    dashboard,
    owner,
    employee,
    faq,
    assessment,
    maintenance,
    resetUser,
    userStatistic
  },
  plugins: [createPersistedState(), plugin],
})

export default store